import React, { createContext, useReducer } from "react";
import { configReducer } from "../reducers/configReducer";
import { NPL_GUEST_CONFIG, isNplDashboardHost } from "../config/nplGuestConfig";

export const ConfigContext = createContext();

const ConfigContextProvider = (props) => {
  const [config, dispatch] = useReducer(
    configReducer,
    isNplDashboardHost() ? NPL_GUEST_CONFIG : { loading: false }
  );

  return (
    <ConfigContext.Provider value={{ config, dispatch }}>
      {props.children}
    </ConfigContext.Provider>
  );
};

export default ConfigContextProvider;
